<template>
  <div>
    <el-card>
      <el-button type="primary" @click="query">保存</el-button>
    </el-card>
    <el-card>
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="模板名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
      </el-form>

      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="模板内容">
          <el-input v-model="form.content"></el-input>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { Message } from "element-ui";
import axiosUtil from "../../utils/AxiosUtils.js";
export default {
  data() {
    return {
      form: {
        name: "",
        content: "",
      },
      id: "",
      tabTypeId:''
    };
  },
  mounted() {
    // this.init();
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.tabTypeId = this.$route.query.tabTypeId;
      this.init();
      
    } else {
      this.id = this.$route.query.tabTypeId;
      
    }
  },
  methods: {
    init() {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.sanbo.health.tab.type.template.select",
          templateId: _this.id,
        },
        ({ code, obj, msg }) => {
          if (code == "0") {
            _this.form.name = obj.templateName;
            _this.form.content = obj.templateContent;
          } else {
            Message({
              message: msg,
              type: "error",
            });
          }
        }
      );
    },
    query() {
      let _this = this;
      if (_this.$route.query.id) {
       axiosUtil(
          {
            service: "smarthos.sanbo.health.tab.type.template.update",
            templateName: _this.form.name,
            templateContent: _this.form.content,
            templateId: _this.id,
            tabTypeId:_this.tabTypeId
          },
          ({ code, obj, msg }) => {
            if (code == "0") {
              Message({
                message: "修改成功",
                type: "success",
              });
              _this.$router.push({ path: "healthyProgrammeList",query: { id: _this.tabTypeId }});
            } else {
              Message({
                message: msg,
                type: "error",
              });
            }
          }
        );
      } else {
         axiosUtil(
          {
            service: "smarthos.sanbo.health.tab.type.template.save",
            templateName: _this.form.name,
            templateContent: _this.form.content,
            tabTypeId: _this.id,
          },
          ({ code, obj, msg }) => {
            if (code == "0") {
              Message({
                message: "添加成功",
                type: "success",
              });
              _this.$router.push({ path: "healthyProgrammeList",query: { id: _this.id }});
            } else {
              Message({
                message: msg,
                type: "error",
              });
            }
          }
        );
        
      }
    },
  },
};
</script>
<style scoped>
</style>